/** Telas do papel INSPETOR — a árvore Região -> Oficina -> Placa, offline (at-114, ADR 0059). */
export const OFICINA_EXTERNA = () => '/oficina-externa';
export const OFICINA_EXTERNA_FILA = () => '/oficina-externa/fila';

/** Acompanhamento para quem não vai à oficina: Chefe de Oficina e setor de Eventos. */
export const OFICINAS_EXTERNAS = () => '/oficinas-externas';
